import { isOneclickUser, isThirdPartyIntegrations } from 'app/policies/config';
import { USER_ROLES } from 'app/services/users.service';

function canPermissions(user) {
  return user?.role_guid !== USER_ROLES.publisher;
}

export function permissionsRol(user) {
  return {
    sectionSettings: canPermissions(user),
    generalSettings: canPermissions(user),
    permissionsSettings: canPermissions(user) && !isThirdPartyIntegrations(user),
    countriesSettings: canPermissions(user),
    disciplinesSettings: canPermissions(user),
    learningObjectivesSettings: canPermissions(user),
    scalesSettings: canPermissions(user),
    tenantParamsSettings: canPermissions(user) && isOneclickUser(user),
  };
}
